import React, { Component } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {mobileCheck, myIsSet} from '../../helpers';
import { postFetch, topicTrendingListFetch } from '../../actions/index';
// import style from './style.css';
import BaseLayout from '../../components/Layout/BaseLayout';
import Loader from '../../components/Common/Loader';
import {Icon} from '../../components/Common/Icon';
import PostsRelatedSidebar from '../../components/Layout/Sidebars/PostsRelated';
import { RelatedArticleCard } from '../../components/SuggestedArticleCard';
import QuestionElemContainer from '../Elems/QuestionElem';
import PollElemContainer from '../Elems/PollElem';
import ArticleElemContainer from '../Elems/ArticleElem';
import VideoElemContainer from '../Elems/VideoElem';
// import EmptyPlaceholder from '../../components/Misc/EmptyPlaceholder';
import Template404Container from '../404';
// import OpenInAppPopup from '../../components/Common/OpenInAppPopup';
//import ImagePopup from '../../components/Common/ImagePopup';
//import PointReward from '../../components/AppDownload/PointReward';
// import { adCoreInit } from '../../components/Ads/Bootstrap';
// import AdPlaceholder from '../../components/Ads/Placeholder';
import AdCoreSlot from '../../components/Ads/AdCoreSlot';
import Breadcrumbs from '../../components/Layout/Breadcrumbs';
import HiddenContentBanner from '../../components/HiddenContentBanner'
import BlockedPostPopup from '../../components/Common/BlockedPostPopup'
import {getUrlParameter} from '@tickled-media/web-components.tm-helpers';
import { translate } from 'react-i18next';
import FeedSwitcherComponent from '../../components/Layout/Sidebars/FeedSwitcher';
import cx from '../../styles';

class ViewContainer extends Component {

    constructor(props) {
        super(props);
        //
        this.dfpArr = [];
        this.state = {
            singleReplyMode: ((props.serverReqQuery && props.serverReqQuery.replyId) || getUrlParameter('replyId')) ? true : false,
            ifOpenInAppModal: false,
            ifOpenRewardPopup: false,
            rightSidebar: [],
            showBackButton: false,
            // replyStatus: false,
            error: false,
            isOpen: false,
            block_user: null
        };
        //ads
        /*if(typeof window != 'undefined') {
            const ads = props.configReducer.ads;
            if(ads.networkId){
                if(props.appReducer.deviceType == 'desktop') {
                    this.dfpArr = [
                        {networkId: ads.networkId, unit: ads.common.half_page.unit, id: ads.common.half_page.id, size: [ads.common.half_page.w, ads.common.half_page.h], collapse: true}
                    ];
                } else {
                    this.dfpArr = [
                        {networkId: ads.networkId, unit: ads.mobile.top.unit, id: ads.mobile.top.id, size: [ads.mobile.top.w, ads.mobile.top.h], collapse: true},
                        {networkId: ads.networkId, unit: ads.common.ros_1st.unit, id: ads.common.ros_1st.id, size: [ads.common.ros_1st.w, ads.common.ros_1st.h], collapse: true},
                        {networkId: ads.networkId, unit: ads.common.ros_2nd.unit, id: ads.common.ros_2nd.id, size: [ads.common.ros_2nd.w, ads.common.ros_2nd.h], collapse: true}
                    ];
                }  
                adCoreInit(this.dfpArr);
            }
        }*/       
    }

    componentDidMount() {
        //if(this.props.match.path == '/q/:slug/:id' && !this.state.showBackButton && document && document.referrer.indexOf(this.props.configReducer.siteUrl) !== -1){
        if(this.props.landingUrl !== this.props.match.url) {
            this.setState({
                showBackButton: true
            })
        }

        //fetch post
        if(this.props.postReducer.id != this.props.match.params.id) {
            const routeParams = this.props.match.params;
            // let locationSearch = this.props.location.search;
            if('id' in routeParams) {
                if(getUrlParameter('replyId')) {
                    this.props.postFetch(routeParams['id'], getUrlParameter('replyId') || '', getUrlParameter('commentId') || '', Number(getUrlParameter('page')) || 1)
                    .then(response => {
                        //if(!response) window.location = '/404';
                        if(response && response.block_user){
                            this.setState({
                                error: true, isOpen: true, block_user: response.block_user
                            })
                        }
                        else if(response == null){
                            window.location = '/feed'
                        }
                        else{
                            const data = response.response.topic;
                            document.title = data.featured_title ? data.featured_title : data.message.split(" ").slice(0,9).join(" ");
                        }
                    });
                    this.setState({singleReplyMode: true});
                } else {
                    this.props.postFetch(routeParams['id'], null, null, Number(getUrlParameter('page')) || 1)
                    .then(response => {
                        if(response && response.block_user){
                            this.setState({
                                error: true, isOpen: true, block_user: response.block_user
                            })
                        }
                        else if(response == null){
                            window.location = '/feed'
                        }
                        else{
                            const data = response.response.topic;
                            document.title = data.featured_title ? data.featured_title : data.message.split(" ").slice(0,9).join(" ");
                        }
                        //if(!response) window.location = '/404';
                        this.setState({singleReplyMode: false});
                    })
                }
            }
        }
        //open in app popup
        /*if(process.env.REACT_APP_ENV == 'production' && this.shouldOpenModal() && this.props.configReducer['region'].region == 'asia') {
            setTimeout(() => {
                this.setState({ifOpenInAppModal: true});
                this.setAsViewedInLocalStorage();
            }, 5000)
        }*/

        //#RewardPopup
        if(mobileCheck() && this.props.configReducer['region'].region === 'asia') {
            this.handleRewardPopupTrigger();
        }
        
        // sidebars
        this.buildRightSidebar();        
        //reset scroll
        window.scrollTo(0,0);
        // if()
    }

    componentDidUpdate(prevProps) {
        //fetch post
        if(prevProps.match.params.id != this.props.match.params.id) {
            const routeParams = this.props.match.params;
            // let locationSearch = this.props.location.search;
            if('id' in routeParams) {
                if(getUrlParameter('replyId')) {
                    this.props.postFetch(routeParams['id'], getUrlParameter('replyId') || '', getUrlParameter('commentId') || '', Number(getUrlParameter('page')) || 1)
                    .then((response) => {
                        if(response && response.block_user){
                            this.setState({
                                error: true, isOpen: true, block_user: response.block_user
                            })
                        }
                        else if(response == null){
                            window.location = '/feed'
                        }
                        else{
                            const data = response.response.topic;
                            document.title = data.featured_title ? data.featured_title : data.message.split(" ").slice(0,9).join(" ");
                        }
                    });
                    this.setState({singleReplyMode: true});
                } else {
                    this.props.postFetch(routeParams['id'], null, null, Number(getUrlParameter('page')) || 1)
                    .then((response) => {
                        if(response && response.block_user){
                            this.setState({
                                error: true, isOpen: true
                            })
                        }
                        else if(response == null){
                            window.location = '/feed'
                        }
                        else{
                            const data = response.response.topic;
                            document.title = data.featured_title ? data.featured_title : data.message.split(" ").slice(0,9).join(" ");
                        }
                    });
                    this.setState({singleReplyMode: false});
                }
            }
            //reset scroll
            window.scrollTo(0,0);
        }
    }

    onModalClose = () => {
        this.setState({isOpen: false})
    }

    handleRewardPopupTrigger = () => {
        let isPopLoad = false;
        try{
            if(window.sessionStorage && 
                Number(window.sessionStorage.getItem('openRewardPopupTriggerCount')) % 3 === 0 &&
                !document.body.classList.contains('ReactModal__Body--open')) {
                isPopLoad = true;
            }
            if(this.state.ifOpenRewardPopup === false && isPopLoad) {
                this.setState({ifOpenRewardPopup: true});
            }

            //#RewardPopup: keep track on RewardPopupTrigger
            if(window.sessionStorage) {
                let count = 1;
                if(window.sessionStorage.getItem('openRewardPopupTriggerCount')) {
                    count = Number(window.sessionStorage.getItem('openRewardPopupTriggerCount')) + 1;
                }
                window.sessionStorage.setItem('openRewardPopupTriggerCount', count);
            }
        }
        catch(e){
            return
        }
    }

    /*setAsViewedInLocalStorage = () => {
        if((typeof window != 'undefined') && window.sessionStorage) {
            window.sessionStorage.setItem('openInAppViewed', 'yes');
        }        
    }*/

    /*shouldOpenModal = () => {
        let retBool = false;
        if((typeof window != 'undefined') && window.sessionStorage) {            
            let viewed = window.sessionStorage.getItem('openInAppViewed');
            if(!viewed && !this.state.ifOpenInAppModal) retBool = true;
        }

        return retBool;
    }*/

    buildSpecificElement = (post) => {
        let elem = null;
        //build
        switch(post.data.type || post.type) {
            case 'question':
                elem = <QuestionElemContainer {...this.props}
                    index={0}
                    match={this.props.match}
                    serverReqQuery={this.props.serverReqQuery}
                    inFeed={false}
                    type={'question'}
                    detailPage={true}
                    id={post.data.topic.id}
                    data={post.data}
                    status={post.data.topic.status}
                    singleReplyMode={this.state.singleReplyMode} 
                />;
            break;
            case 'poll':
                elem = <PollElemContainer {...this.props}
                    index={0}
                    match={this.props.match}
                    serverReqQuery={this.props.serverReqQuery}
                    inFeed={false}
                    type={'poll'}
                    id={post.data.topic.id}
                    data={post.data}
                    status={post.data.topic.status}
                    singleReplyMode={this.state.singleReplyMode} 
                />;
            break;
            case 'article':
                elem = <ArticleElemContainer {...this.props}
                    index={0}
                    inFeed={false}
                    match={this.props.match}
                    serverReqQuery={this.props.serverReqQuery}
                    type={'article'}
                    id={post.data.topic.id}
                    data={post.data}
                    status={post.data.topic.status}
                    singleReplyMode={this.state.singleReplyMode} />;
            break;
            case 'video':
                elem = <VideoElemContainer {...this.props}
                    index={0}
                    inFeed={false}
                    match={this.props.match}
                    serverReqQuery={this.props.serverReqQuery}
                    type={'video'}
                    id={post.data.topic.id}
                    data={post.data}
                    status={post.data.topic.status}
                    singleReplyMode={this.state.singleReplyMode} />;
            break;
            default:
                elem = null;
        }
        return elem;
    }

    buildAdSlots = () => {
        // const ads = this.props.configReducer.ads;
        const dfp = this.props.configReducer.dfp;
        const app = this.props.appReducer;
        const post = this.props.postReducer;

        return [
            !(post.data && post.data.topic && post.data.topic.nsfw === 1) &&
            dfp.networkId && myIsSet(dfp, 'ros.banners.side_1_d.id') &&
            <div className={cx("shadow-card")}>
                {/*<AdCoreSlot networkId={ads.networkId} 
                    adUnit={ads.common.half_page.unit}
                    styleClass={ads.common.half_page.styleClass}
                    size={[ads.common.half_page.w, ads.common.half_page.h]}
                    id={ads.common.half_page.id}/>*/}
                <AdCoreSlot 
                    dfpKeys={['ros','banners','side_1_d']}
                    adObj={dfp.ros.banners.side_1_d}
                    device="desktop"
                    customClass="showAddText"
                    styleClass={dfp.ros.banners.side_1_d.styleClass} 
                    id={dfp.ros.banners.side_1_d.id}
                    app={this.props.appReducer}
                />
            </div>,
            app.postsRelatedSidebar && app.postsRelatedSidebar.length > 0
            ?
                <PostsRelatedSidebar elems={app.postsRelatedSidebar} postData={post.data}/>
            : '',
            app.postsTrendingSidebar && app.postsTrendingSidebar.length > 0 
            ?
                <PostsRelatedSidebar elems={app.postsTrendingSidebar} isTrending={true} postData={post.data}/>
            : '',
            !(post.data && post.data.topic && post.data.topic.nsfw === 1) &&
            dfp.networkId && myIsSet(dfp, 'ros.banners.side_2_d.id') &&
            <div className={cx("shadow-card")}>
                <AdCoreSlot 
                    dfpKeys={['ros','banners','side_2_d']}
                    adObj={dfp.ros.banners.side_2_d}
                    device="desktop"
                    customClass="showAddText"
                    styleClass={dfp.ros.banners.side_2_d.styleClass} 
                    id={dfp.ros.banners.side_2_d.id}
                    app={this.props.appReducer}
                />
            </div>,
            !(post.data && post.data.topic && post.data.topic.nsfw === 1) &&
            dfp.networkId && myIsSet(dfp, 'ros.banners.side_4.id') &&
            <div className={cx("shadow-card")}>
                <AdCoreSlot 
                    dfpKeys={['ros','banners','side_4']}
                    adObj={dfp.ros.banners.side_4}
                    device="desktop"
                    customClass="showAddText"
                    styleClass={dfp.ros.banners.side_4.styleClass} 
                    id={dfp.ros.banners.side_4.id}
                    app={this.props.appReducer}
                />
            </div>,
        ];  
    }

    checkRepliesStatus = () => {
        const post = this.props.postReducer;
        const replies = post.data.replies;
        for(let i = 0; i < replies.length; i++){
            if(replies[i].status == 0){
                return true;
            }
            else{
                return false;
            }
        }
    }

    buildLeftSidebar = () => {
        // let appDownloadCreative =
        //     <div className={cx("shadow-card")}>
        //         <a href="https://community.theasianparent.com/app/download?utm_source=community-static-banner&utm_medium=web&utm_campaign=app-download">
        //             <img src={this.props.configReducer['region'].staticAd3} loading="lazy"/>
        //         </a>
        //     </div>;        

        // let postsRelatedSidebar = this.props.appReducer.postsRelatedSidebar.length ? <PostsRelatedSidebar elems={this.props.appReducer.postsRelatedSidebar}/> : null;
        // return [postsRelatedSidebar].filter(cell => cell);
        
        const lc = [
            <FeedSwitcherComponent trendingTopicsElems={this.props.appReducer.topicsTrendingSidebar} appReducer={this.props.appReducer} />,
        ];

        return lc;
    }

    buildRightSidebar = () => {
        const adSlots = this.buildAdSlots();
        const rightSidebar = adSlots;

        if(!mobileCheck() && !this.props.appReducer.topicsTrendingSidebar.length){
            this.props.topicTrendingListFetch();
        }

        this.setState({rightSidebar});
    }

    render() {
        const t = this.props.t;
        const post = this.props.postReducer;
        // const siteUrl = this.props.configReducer.siteUrl;
        const ads = this.props.configReducer.ads;
        const app = this.props.appReducer;

        //let lc = this.props.appReducer.deviceType == 'desktop' ? this.buildLeftSidebar() : [];
        // let rc = this.props.appReducer.deviceType == 'desktop'
        //     ? (this.state.rightSidebar.length ? this.state.rightSidebar : [<div className={cx("shadow-card")}><AdPlaceholder w="320" h="250"/></div>])
        //     : this.buildLeftSidebar();//switch

        //image popup
        /*var desktopImg = "";
        var mobileImg = "";        
        let country = this.props.appReducer.country;
        switch(country) {
            case 'th':
                desktopImg = generateAssetCdnUrl("parenttown-prod/popup", "TH.png");
                mobileImg = generateAssetCdnUrl("parenttown-prod/popup", "TH.png");
            break;
            case 'id':
                desktopImg = generateAssetCdnUrl("parenttown-prod/popup", "ID.png");
                mobileImg = generateAssetCdnUrl("parenttown-prod/popup", "ID.png");
            break;
            case 'vn':
                desktopImg = generateAssetCdnUrl("parenttown-prod/popup", "VN.png");
                mobileImg = generateAssetCdnUrl("parenttown-prod/popup", "VN.png");
            break;
            case 'my':
                desktopImg = generateAssetCdnUrl("parenttown-prod/popup", "MY.png");
                mobileImg = generateAssetCdnUrl("parenttown-prod/popup", "MY.png");
            break;
            case 'ng':
                desktopImg = generateAssetCdnUrl("community-africaparent", "23million_africa.png");
                mobileImg = generateAssetCdnUrl("community-africaparent", "23million_africa.png");
            break;
            default:
                desktopImg = generateAssetCdnUrl("parenttown-prod/popup", "SG.png");
                mobileImg = generateAssetCdnUrl("parenttown-prod/popup", "SG.png");
        }*/
        if(this.state.error) {
            return(
                <div className={cx('view-post')} >
                    <Template404Container history={this.props.history} match={this.props.match} />
                    <BlockedPostPopup isOpen={this.state.isOpen} onModalClose={this.onModalClose} block_user={this.state.block_user} t={t}/>
                </div>
            )
        }
        else if(this.props.postReducer.isLoading && !post.id){
            return (
                <div className={cx('view-post')} >
                    <BaseLayout 
                        history={this.props.history} 
                        match={this.props.match}
                        landingUrl={this.props.landingUrl}
                        serverReqCookie={this.props.serverReqCookie}
                        leftCards={this.buildLeftSidebar()} 
                        rightCards={
                            this.state.rightSidebar.length
                            ?
                                [...this.state.rightSidebar]
                            :
                                [
                                    ...this.state.rightSidebar,
                                    app.postsRelatedSidebar && app.postsRelatedSidebar.length > 0 ?
                                    <PostsRelatedSidebar elems={app.postsRelatedSidebar} postData={post.data}/> : '',
                                    app.postsTrendingSidebar && app.postsTrendingSidebar.length > 0 ?
                                    <PostsRelatedSidebar elems={app.postsTrendingSidebar} isTrending={true} postData={post.data}/> : ''
                                ]
                        } 
                    >
                        <Loader />
                    </BaseLayout>
                </div>
            )
        }
        else{
            return (
                <div className={cx('view-post')} >
                    <BaseLayout 
                        history={this.props.history} 
                        landingUrl={this.props.landingUrl}
                        match={this.props.match}
                        serverReqCookie={this.props.serverReqCookie}
                        showBackButton={this.state.showBackButton}
                        leftCards={this.buildLeftSidebar()}
                        rightCards={
                            this.state.rightSidebar.length
                            ?
                                [...this.state.rightSidebar]
                            :
                                [
                                    ...this.state.rightSidebar,
                                    app.postsRelatedSidebar && app.postsRelatedSidebar.length > 0 ?
                                    <PostsRelatedSidebar elems={app.postsRelatedSidebar} postData={post.data}/> : '',
                                    app.postsTrendingSidebar && app.postsTrendingSidebar.length > 0 ?
                                    <PostsRelatedSidebar elems={app.postsTrendingSidebar} isTrending={true} postData={post.data}/> : ''
                                ]
                        }
                    >
                        {
                         /*  <div className={cx("only-mobile", "ad-wrap")}>
                                {
                                    mobileCheck() && !!this.dfpArr.length &&
                                    <AdCoreSlot networkId={ads.networkId} 
                                        adUnit={ads.mobile.top.unit}
                                        styleClass={ads.mobile.top.styleClass}
                                        size={[ads.mobile.top.w, ads.mobile.top.h]}
                                        id={ads.mobile.top.id} />
                                }
                            </div> */
                        }

                        {
                            this.state.showBackButton &&
                            <div className={cx('not-mobile', 'back-btn')} onClick={() => this.props.history.goBack()}>
                                <span>
                                    <Icon name='btn-back'/>
                                </span>
                                <span>{t('question')}</span>
                            </div>
                        }
                        {
                            post && post.data &&
                            ((post.data.topic && post.data.topic.status === 0) || 
                            (post.data.replies && this.state.singleReplyMode  && this.checkRepliesStatus() ))  &&
                            <HiddenContentBanner data={post.data.alert_banner}/>
                        }
                        {
                            this.buildSpecificElement(post)
                        }

                        {/*
                            post.id
                            ? this.buildSpecificElement(post)
                            : <EmptyPlaceholder content={this.props.t('search_empty')} />
                        */}

                        <div className={cx("only-mobile", "ad-wrap")}>
                            {
                                mobileCheck() && !!this.dfpArr.length && ads.networkId &&
                                <AdCoreSlot networkId={ads.networkId} 
                                    adUnit={ads.common.ros_1st.unit}
                                    styleClass={ads.common.ros_1st.styleClass}
                                    size={[ads.common.ros_1st.w, ads.common.ros_1st.h]}
                                    id={ads.common.ros_1st.id} />
                            }
                        </div>

                        {   
                            this.props.appReducer.postsRelatedSidebar.length > 0 &&
                            <div className={cx("only-mobile")}>
                                <PostsRelatedSidebar elems={this.props.appReducer.postsRelatedSidebar} postData={post.data}/>
                            </div>

                        }

                        {   
                            this.props.appReducer.postsTrendingSidebar.length > 0 &&
                            <div className={cx("only-mobile")}>
                                <PostsRelatedSidebar elems={this.props.appReducer.postsTrendingSidebar} isTrending={true} postData={post.data}/>
                            </div>

                        }

                        {   
                            this.props.appReducer.relatedArticleSidebar.length > 0 &&
                            <div className={cx("only-mobile")}>
                                <RelatedArticleCard elems={this.props.appReducer.relatedArticleSidebar} t={t} match={this.props.match}/>
                            </div>
                        }

                        {/*
                        <ImagePopup isModalOpen={this.state.ifOpenInAppModal}
                            onClose={() => this.setState({ifOpenInAppModal: false})}
                            url={"/app/download?utm_source=community-popup-banner&utm_medium=web&utm_campaign=app-download"}
                            imgUrlDesktop={desktopImg}
                            imgUrlMobile={mobileImg} />
                        */}
                       
                        {/*<PointReward isModalOpen={this.state.ifOpenRewardPopup}
                            onClose={() => this.setState({ifOpenRewardPopup: false})}
                            appReducer={this.props.appReducer} 
                            configReducer={this.props.configReducer}
                        />*/}

                        {/* this.props.postReducer.isLoading && !this.props.appReducer.showLoginModal && <Loader /> */}

                        <div className={cx("only-mobile", "ad-wrap")}>
                            {
                                mobileCheck() && !!this.dfpArr.length && ads.networkId &&
                                <AdCoreSlot networkId={ads.networkId} 
                                    adUnit={ads.common.ros_2nd.unit}
                                    styleClass={ads.common.ros_2nd.styleClass}
                                    size={[ads.common.ros_2nd.w, ads.common.ros_2nd.h]}
                                    id={ads.common.ros_2nd.id} />
                            }
                        </div>
                        <Breadcrumbs links={[
                            {location: '/feed', label: 'Home'},
                            {location: '/topic/' + (post.data.topic ? post.data.topic.group.slug : ''), label: (post.data.topic ? post.data.topic.group.name : '')},
                            {location: this.props.location.pathname, label: this.props.match.params.slug.replace(/-/g, " ")}
                        ]} />
                    </BaseLayout>
                </div>
            );
        }
    }

}

//map state
const mapStateToProps = (state) => {
    // console.log(state);
    return state;
}

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        postFetch,
        topicTrendingListFetch
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(ViewContainer));
